import { render, staticRenderFns } from "./ComplaintDetail.vue?vue&type=template&id=6d1a4c2a&scoped=true"
import script from "./ComplaintDetail.vue?vue&type=script&lang=js"
export * from "./ComplaintDetail.vue?vue&type=script&lang=js"
import style0 from "./ComplaintDetail.vue?vue&type=style&index=0&id=6d1a4c2a&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d1a4c2a",
  null
  
)

export default component.exports